import { create } from "zustand";
import { SLA_INDICATOR_LIST } from "../../Utils/constant";
import { find } from "../../services/service";
export const useSlaStore = create((set) => ({
  loading: false,
  data: [],
  getData: async () => {
    set({
      loading: true,
      data: [],
    });

    try {
      const sla = await find(SLA_INDICATOR_LIST);
      set({
        loading: false,
        data: sla.data,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
}));
